<template>
  <g class="hc-legend">
    <rect
      class="hc-legend-rect"
      v-for="(rec, index) in recs"
      :key="index"
      :x="rec.x"
      :y="rec.y"
      :width="rec.w"
      :height="rec.h"
      :fill="rec.color"
    />
    <text
      class="hc-legend-text"
      text-anchor="end"
      v-for="(rec, index) in recs"
      v-if="index !== recs.length - 1"
      :key="'text' + index"
      :x="rec.x"
      :y="rec.y"
      dx="-4"
      dy="4"
    >{{start + 5 * index}}%</text>
  </g>
</template>

<script>
export default {
  name: 'ColorLegend',
  props: {
    scale: {
      type: Function,
      default (i) {return '#333'}
    },
    w: {
      type: Number,
      default: 8
    },
    h: {
      type: Number,
      default: 30
    },
    x: {
      type: Number,
      default: 0
    },
    y: {
      type: Number,
      default: 0
    },
    start: {
      type: Number,
      default: -10
    },
    end: {
      type: Number,
      default: 20
    }
  },
  data () {
    return {
      steps: 7,
      size: 20
    }
  },
  computed: {
    recs () {
      let recs = []
      for (let i = 0; i < this.steps; i++) {
        recs.push({
          x: this.x,
          y: this.y + (this.h + 1) * (this.steps - 1 - i),
          w: this.w,
          h: this.h,
          color: this.scale(i)
        })
      }
      return recs
    }
  }
}
</script>

<style>
</style>
